import { useMutation } from '@apollo/client';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import {
  CREATE_GITHUB_APP_AUTHORIZATION_URL,
  CreateGitHubAppAuthorizationUrlMutation,
  CreateGitHubAppAuthorizationUrlMutationVariables,
} from '../graphql';
import { useCurrentCompanyId } from './useCurrentCompanyId';
import { useCurrentUser } from './useCurrentUser';
import { getGitHubAppReturnUrl } from './useGitHubAppConnect';

export const useGitHubAppAuthorization = (): {
  authorize: () => Promise<void>;
  loading: boolean;
  error: boolean;
} => {
  const companyId = useCurrentCompanyId();
  const { user } = useCurrentUser();
  const location = useLocation();
  const [error, setError] = useState(false);
  const [createAuthorizationUrl, { loading }] = useMutation<
    CreateGitHubAppAuthorizationUrlMutation,
    CreateGitHubAppAuthorizationUrlMutationVariables
  >(CREATE_GITHUB_APP_AUTHORIZATION_URL);

  const authorize = async (): Promise<void> => {
    if (!user) {
      setError(true);
      return;
    }
    setError(false);
    try {
      const { data } = await createAuthorizationUrl({
        variables: {
          userId: user.id,
          input: { companyId, returnUrl: getGitHubAppReturnUrl(location) },
        },
      });
      const url = data?.createGitHubAppAuthorizationUrl;
      if (url) {
        window.location.assign(url);
      } else {
        setError(true);
      }
    } catch {
      setError(true);
    }
  };

  return { authorize, loading, error };
};
